import Svg, { Path } from 'react-native-svg';
import Settings from 'src/Settings';

interface IProps {
  color?: string;
  width?: number;
  height?: number;
}

const NewOffersTabIconFilled = ({
  color = Settings.isRefive() ? '#3070ED' : '#066DFF',
  width = 23,
  height = 26,
}: IProps) => (
  <Svg width={width} height={height} viewBox="0 0 23 26" fill="none">
    <Path
      d="M10.1987 1.625C11.0335 1.625 11.8339 1.96523 12.4232 2.57461L21.0661 11.5121C22.2937 12.7816 22.2937 14.8383 21.0661 16.1078L14.5103 22.8871C13.2826 24.1566 11.2937 24.1566 10.0661 22.8871L1.42321 13.9496C0.829018 13.3402 0.5 12.5176 0.5 11.6543V4.0625C0.5 2.7168 1.5558 1.625 2.85714 1.625H10.1987Z"
      fill={color}
    />
  </Svg>
);

export default NewOffersTabIconFilled;